import { VStack, Box, BoxProps } from '@chakra-ui/react'
import * as React from 'react'

import { TextBody, TextBodyBold1, TextBodyBold2, TextHeadline1, TextSubtitle } from '../common/Text'
import { vw } from '../../styles/theme'
import useLocale from '../../hooks/useLocale'

export type TopOutlineProps = BoxProps & {}

const TopOutline: React.FC<TopOutlineProps> = ({ ...others }) => {
  const { isJa } = useLocale()
  return (
    <>
      <Box pt={[vw(132), '185px']} {...others}>
        <Box w={['contentSP', '660px']} m="0 auto" textAlign={['center', 'left']}>
          <Box mb={[vw(60), '60px']}>
            <TextHeadline1 as="h2" localizeKey="top__outline__title" lineHeight="1" />
          </Box>
          <Box mb={[isJa ? vw(30) : '0', isJa ? '30px' : '0']}>
            <TextSubtitle as="h3" localizeKey="top__outline__subtitle_1" />
            <TextBodyBold1 localizeKey="top__outline__subtitle__en_1" color="text.200" />
          </Box>
          <Box mb={[vw(55), '50px']}>
            <TextBodyBold1 localizeKey="top__outline__subtitle_2" />
            <TextBodyBold1 localizeKey="top__outline__subtitle_en_2" color="text.200" />
          </Box>

          <VStack alignItems={['center', 'flex-start']} spacing={[vw(60), '30px']}>
            {Array(8)
              .fill(0)
              .map((_, i) => {
                const num = i + 1
                return (
                  <Box key={i}>
                    <TextBodyBold2 localizeKey={`top__outline__content_title_${num}`} />
                    <TextBody localizeKey={`top__outline__content_body_${num}`} />
                  </Box>
                )
              })}
          </VStack>
        </Box>
      </Box>
    </>
  )
}

export default TopOutline
